import React from "react";
import ReactDOM from "react-dom/client";
import AukusPolicyGeneration from "./aukus-policy-generation";
import "../../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AukusPolicyGeneration />
  </React.StrictMode>,
);
